module.exports = __webpack_public_path__ + "img/lumavera01.9387afcd.jpg";